import { render, staticRenderFns } from "./SliderNav.vue?vue&type=template&id=ad97e51c&scoped=true&"
import script from "./SliderNav.vue?vue&type=script&lang=js&"
export * from "./SliderNav.vue?vue&type=script&lang=js&"
import style0 from "./SliderNav.vue?vue&type=style&index=0&id=ad97e51c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad97e51c",
  null
  
)

export default component.exports